import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {CardMetric} from '../CardMetric';
import styles from '../../ListingCard.scss';
import * as locales from '../../locales';

interface CardMetricsProps {
  shop: Shop;
}

export class CardMetricsComponent extends React.PureComponent<CardMetricsProps & WithI18nProps> {
  render() {
    const {shop, i18n} = this.props;
    const metrics = [
      {
        label: i18n.translate('avgRevenue'),
        frequency: i18n.translate('month'),
        value: shop.averageMonthlyRevenue,
      },
      {
        label: i18n.translate('avgProfit'),
        frequency: i18n.translate('month'),
        value: shop.averageProfitPerMonth,
      },
      {
        label: i18n.translate('inventoryValue'),
        value: shop.inventoryValue,
      },
    ];

    return (
      <dl className={classNames(styles.metrics, styles.noMargin)}>
        {metrics.map((metric) => (
          <CardMetric key={metric.label} metric={metric} />
        ))}
      </dl>
    );
  }
}

export const CardMetrics = withI18n({
  id: 'CardMetrics',
  fallback: locales.en,
})(CardMetricsComponent);
